import { View } from './view';
import { ErrorType } from '../config/error-type';
import { Translations } from '../config/translations';
import { PaymentType } from '../providers/payment-type';

export class ErrorView extends View {

    errors = {
        [ErrorType.PROTOCOL_NOT_SECURED]: Translations.PROTOCOL_NOT_SECURED,
        [ErrorType.ACCOUNT_HAS_EXPIRED]: Translations.ACCOUNT_HAS_EXPIRED,
        [ErrorType.CAPTCHA_EXISTS]: Translations.CAPTCHA_EXISTS,
        [ErrorType.SERVER_NOT_AVAILABLE]: Translations.SERVER_NOT_AVAILABLE
    };

    async render(errorType: ErrorType, errorResponse?: any) {
        const errorElement = document.createElement('p');
        errorElement.setAttribute('id', 'df-main-error');
        errorElement.innerText = this.getErrorMessage.bind(this)(errorType, errorResponse);
        let container = document.getElementById('df-card-container');
        if (container) {
            container.insertBefore(errorElement, container.firstChild);
        } else {
            container = document.createElement('div');
            container.setAttribute('id', 'df-card-container');
            errorElement.style.color = 'red';
            errorElement.style.fontSize = '18px';
            errorElement.style.fontWeight = 'normal';
            container.appendChild(errorElement);
            document.body.appendChild(container);
        }
    }

    private getErrorMessage(errorType: ErrorType, errorResponse?: any) {
        if (errorResponse) {
            return errorResponse.errorMessage || errorResponse.message || Translations.SERVER_NOT_AVAILABLE;
        }
        return this.errors[errorType];
    }

    getErrorContainer(paymentType: PaymentType) {
        switch (paymentType) {
            case PaymentType.STRIPE:
                return '#stripe_error';
            case PaymentType.STRIPE_GOOGLE_PAY:
                return '#stripe_mobile_pay_error';
            case PaymentType.STRIPE_APPLE_PAY:
                return '#stripe_mobile_pay_error';
            case PaymentType.STRIPE_ACH:
                return '#stripe_ach_error';
            case PaymentType.STRIPE_BACS:
                    return '#stripe_bacs_error';
            case PaymentType.PAYPAL:
                return '#paypal_error';
            case PaymentType.OFFLINE:
                return '#offline_error';
        }
    }

}
